<template>
    <div>
        <div v-for="(question, index) in questionObj" :key="index">
            <div v-if="index === quesIndex">
                <QuestionElementEmbedded @checked="ansSelected" embedded
                    :source="question.code"
                    :ques="question.question"
                    :options="question.options"
                    :currIndex="quesIndex + 1"
                    :ans="question.answer"
                    :totalQuestions="questionObj.length">
                </QuestionElementEmbedded>
                <PurpleButton v-if="!completed && quesIndex !== total-1" @pressed="nextQues" buttonText="Next Question"></PurpleButton>
                <PurpleButton v-else-if="!completed" @pressed="nextQues" buttonText="Done"></PurpleButton>
            </div>

            
        </div>
    </div>   
</template>

<script>
import PurpleButton from './PurpleButton.vue'
import QuestionElementEmbedded from './QuestionElementEmbedded.vue'
export default {
    name: 'EmbeddedQuiz',
    components: {
        PurpleButton,
        QuestionElementEmbedded
    },
    props: {
        questionObj: Array,
    },
    data: function() {
        return {
            quesIndex: 0,
            selected: '',
            num_correct: 0,
            num_wrong: 0,
            total: this.questionObj.length,
            score: 0,
            completed: false
        }
    },
    mounted: function() {
        console.log("in mounted, total num of questions is " + this.total);
    },
    methods: {
        ansSelected: function(isCorrect) {
            //alert('answer is ' + answer);
            if (isCorrect) {
                this.num_correct++;
            } else {
                this.num_wrong++;
            }

            /*if ((this.quesIndex + 1) === this.total) {
                this.score = ((this.num_correct*100)/this.total);
                
                this.completed = true;
                this.$emit('completed', this.score);
                if (this.score === 100) 
                alert('congrats you\'ve completed this section!');
                
            }*/
        },
        evalAns: function(quesObj) {
            alert('submitted is ' + this.selected + ' and correct ans is ' + quesObj.answer);
        },
        nextQues: function() {
            console.log("the length of the array is " + this.questionObj.length);
            if ((this.quesIndex + 1) < this.questionObj.length)
            this.quesIndex++;

            else {
                this.score = Math.ceil((this.num_correct*100)/this.total);
                
                this.completed = true;
                this.$emit('completed', this.score);
                
            }
        }
    }
}
</script>


<style scoped>

</style>
